module.exports = require('./helpers/bundle-url').getBundleURL('gA8FI') + "ham-company.5f8ce858.png";